<template>

  <div id="dialog-ratingView">
    <div class="dialog">
      <span class="cls" @click="cancel"></span>
      <div class="paper">
        <div class="header"> <h2>별점 평가</h2> </div>
        <div class="content">
          <a v-for="n in 5" :key="n" class="star" @click="Rate = n">
            <i :class="n <= Rate ? 'ph-fill ph-star on' : 'ph ph-star'"></i>
          </a>
        </div>
        <button @click="submitRate">확인</button>
      </div>
    </div>
  </div>

</template>


<script>
import { ref } from "vue"

export default {
  props:{
    defaultRate: Number,
  },
  emits: ['submit'],
  setup(props, { emit }) {

    const Rate = ref(props.defaultRate || 0);

    function submitRate() {
      emit('submit', { rate: Number(Rate.value) });
    }

    function cancel() {
      emit('submit', { rate: null })
    }

    return {
      submitRate,
      cancel,
      Rate
    }
  }
}
</script>


<style scoped>
#dialog-ratingView {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  backdrop-filter: blur(2px);
}

.dialog > .cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.dialog > .paper {
  width: 90%;
  max-width: 480px;
  min-height: 10%;
  height:fit-content;
  background: var(--color-background);
  border: 2px solid var(--color-background-light);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  gap: 24px;
  display: flex;
  flex-direction: column;
}

.header {
  width:100%;
  height:var(--font-size-3xl);
  display:flex;
  justify-content: center;
  align-items:center;
}

.header > h2 {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin:0;
  padding:0;
}

.content {
  width:100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap:12px;
}

.star {
  cursor: pointer;
  font-size: var(--font-size-4xl);
  color: var(--color-text-secondary);
}

.on {
  color: var(--color-brand);
}

button {
  width: 100%;
  height: var(--font-size-3xl);
  background-color: var(--color-brand);
  color: var(--color-text-black);
  font-weight: var(--font-weight-bold);
  border: none;
  border-radius: 8px;
  font-size: var(--font-size-lg);
  cursor: pointer;
}
</style>
